var map = {
	"./1.svg": 241,
	"./2.svg": 242,
	"./3.svg": 243,
	"./4.svg": 244,
	"./5.svg": 245,
	"./6.svg": 246,
	"./7.svg": 247,
	"./8.svg": 248,
	"./9.svg": 249
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 240;